import { observer } from 'mobx-react-lite';
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonButtons,
  IonTitle,
  IonContent,
  IonBackButton
} from '@ionic/react';
import WorkoutAssignmentSingle from '../components/WorkoutSingle';
import workoutAssignmentStatusStore from 'stores/workout-assignment-status.store';

import classes from './style.module.scss';

const WorkoutSinglePage = ({ match, history }) => {
  const urlSearchParams = new URLSearchParams(history.location.search);
  const workoutAssignmentId = match.params.id;
  const workoutName = urlSearchParams.get('name');

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot='start'>
            <IonBackButton></IonBackButton>
          </IonButtons>
          <IonTitle>{workoutName}</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent className={classes.ionContent}>
        <WorkoutAssignmentSingle workoutAssignmentId={workoutAssignmentId} />
      </IonContent>
    </IonPage>
  );
};

export default observer(WorkoutSinglePage);
